module.exports = __webpack_public_path__ + "static/revolutionuc-a9eb0042265b80046df5d45e19daebd4.jpg";